import type { ReactNode } from 'react';
import { ArrowLeft } from 'lucide-react';
import { cn } from '@eombor/ui';

export interface BackButtonProps {
  onClick: () => void;
  children: ReactNode;
  className?: string;
}

/**
 * ORQAGA QAYTISH tugmasi — sahifa sarlavhasi ustida.
 *
 * `Button` ning `ghost` varianti bu yerda ko'zdan qochib, oddiy matnga
 * o'xshab qolardi, `secondary` esa yonidagi amallar bilan qo'shilib ketardi.
 * Shuning uchun o'z ko'rinishi: och ko'k fon va ko'k yozuv — sahifadagi
 * boshqa tugmalardan ajralib turadi, lekin asosiy harakatdek baqirmaydi.
 * Hover da to'liq ko'k bo'ladi: bosiladigan narsa ekani aniq ko'rinsin.
 *
 * O'lcham va shrift `Button size="sm"` bilan bir xil.
 */
export const BackButton = ({ onClick, children, className }: BackButtonProps) => (
  <button
    type="button"
    onClick={onClick}
    className={cn(
      'inline-flex h-[var(--size-control-sm)] items-center gap-2 px-3.5 whitespace-nowrap',
      'rounded-[var(--radius-sm)] border text-sm font-medium select-none',
      'border-accent/30 bg-accent-soft text-accent',
      'hover:border-accent hover:bg-accent hover:text-accent-contrast',
      'transition-[background-color,border-color,color,transform]',
      'duration-[var(--motion-fast)] ease-[var(--ease-standard)]',
      'active:translate-y-[0.5px]',
      className,
    )}
  >
    <ArrowLeft size={16} aria-hidden />
    {children}
  </button>
);
